<template>
  <v-dialog
    v-model="dialog"
    :width="width"
    @keydown.esc="$emit('closeDialog')"
    @keydown.enter="
      $emit(
        actions[0].action_name,
        actions[0].action_value1,
        actions[0].action_value2
      )
    "
  >
    <v-card>
      <v-text-field
        ref="input"
        :disabled="true"
        :value="title"
        class="card-header__header modal_head"
        hide-details
      />

      <v-card-text>
        <slot name="body" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          flat
          data-tid="cancel_button"
          @click="$emit('closeDialog')"
        >
          <span v-if="cancelLabel">{{ cancelLabel }}</span>
          <span v-else>Cancel</span>
        </v-btn>
        <v-btn
          v-for="(item, key) in actions"
          :key="'name_' + key"
          :color="item.button_color"
          data-tid="action_button"
          @click="
            $emit(item.action_name, item.action_value1, item.action_value2)
          "
        >
          {{ item.label }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: "500",
    },
    title: {
      type: String,
      required: true,
    },
    cancelLabel: {
      type: String,
      required: false,
      default: "",
    },
    actions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.$emit("closeDialog");
      } else {
        requestAnimationFrame(() => {
          const refs_content = this.$children[0].$refs.content;
          if (refs_content.querySelector(".autofocus")) {
            refs_content
              .querySelector(".autofocus")
              .querySelector("input")
              .focus();
          }
        });
      }
    },
    show(value) {
      this.dialog = value;
    },
  },
};
</script>

<style lang="scss">
.v-dialog {
  .v-card {
    padding: 10px 40px 12px 40px;
  }
  .modal_head.v-text-field.v-input--is-disabled .v-input__slot {
    &:before {
      border-image: none !important;
    }
    input {
      color: inherit;
    }
  }
  .v-card__text {
    padding: 16px 0 0;
    margin-bottom: -5px;
    .v-text-field {
      margin-bottom: 5px;
    }
    .v-text-field__details {
      padding-left: 0;
    }
  }
  .v-card__actions {
    padding: 6px 0 13px;
  }
}
</style>
